// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {CategoriesModuleLayout} from 'app_components/modules/academic/categories'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface ICategoriesModuleProps {
  container: string;
  currentCategory?: string
  onHandleCategory?: (category: any) => void
}
interface ICategoriesModuleState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class CategoriesModule extends Component<ICategoriesModuleProps, ICategoriesModuleState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ICategoriesModuleProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    // setTimeout(() => {
    //   let categories: Array<any>=[];
    //   this.setState({
    //     loading: false
    //   })
    // }, 1000)
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <CategoriesModuleLayout
        container={this.props.container}
        currentCategory={this.props.currentCategory}
        onHandleCategory={this.props.onHandleCategory}
      />
    )
  }
}

export default connect(mapStatesToProps)(CategoriesModule)
